// extracted by mini-css-extract-plugin
export var container = "_4b-0";
export var containerTopRight = "_4b-1";